import { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { GetFetch, urls } from '../services/apiBase';

const AppContext = createContext();

const AppStatusProvider = ({ children }) => {

  const [openDrawer, setOpenDrawer] = useState(false);
  const [summarization, setSummarization] = useState({});
  const [ticketSummarization, setTicketSummarization] = useState({});

  const toggleDrawer = (value) => {
    setOpenDrawer(value);
  }

  const getCprSummarization = async() => {
    try {

      const { data } = await GetFetch(urls.GET_SUMMARIZATION);
      setSummarization(data)
    } catch (error) {
      console.log(error);
    }
  }

  const getTicketsSumarization = async() => {
    try {

      const balanceExpired = await GetFetch(`/tickets?name=BALANCE_EXPIRED&closed=false`);
      const cprRenew = await GetFetch(`/tickets?name=CPR_RENEW&closed=false`);
      const cancelTickets = await GetFetch(`/tickets?name=CANCEL_ACCOUNT&closed=false`);
      const waiverTickets = await GetFetch(`/tickets/pendingWaiverCount`);

      setTicketSummarization({
        ticketsSaldoConta : balanceExpired.data.total,
        ticketsRenovacao : cprRenew.data.total,
        cancelTickets : cancelTickets.data.total,
        waiverTickets : waiverTickets.data,
      })

    } catch (error) {
      console.log(error);
    }
  }

  return (
    <AppContext.Provider
      value={{
        openDrawer: openDrawer,
        summarization: summarization,
        ticketSummarization: ticketSummarization,
        toggleDrawer,
        getCprSummarization,
        getTicketsSumarization
      }}>
      {children}
    </AppContext.Provider>
  );
};

function useAppStatus() {
  const context = useContext(AppContext);

  return context;
}
  
export { AppStatusProvider, useAppStatus };